
import React, { useEffect, useRef, useState, ReactNode, cloneElement } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    TextField,
    Card,
    CardContent,
    Tabs,
    Tab,
    Divider,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Grid,
    Avatar,
    Button,
    Popover,
    LinearProgress
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from "@mui/icons-material/Check";
import ScheduleIcon from "@mui/icons-material/Schedule";
import RemoveIcon from '@mui/icons-material/Remove';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import {useTheme, alpha} from '@mui/material/styles';
import {SparkLineChart} from "@mui/x-charts/SparkLineChart";
import {LayoutFieldModel,
        IconType,
        IconJSON} from '../../models/models';
import {CartAModel,
        CartAJSON,
        CartAFactory,
        EventProductModel,
        ProductModel} from '../../models/modelsCart';
import {formatPrice} from '../../utils/priceFunctions';
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';
import {KPICardFigure,
        KPICardText,
        KPICardIcon,
        KPICardTrend,
        KPICardSparkline} from '../../models/modelsDashboard';
import {CustomIconComponent} from '../icons/CustomIcon';
import { useAuth } from "../../hooks/useAuth";
import { retrieveCart,
         refreshCart,
         submitCart } from "../../services/cartApi";
import {useSnackbar} from "notistack";
import {getAppName,
        getObjectName} from "../../utils/helperRouter";
import { useNavigate } from "react-router";
import {useParams} from "react-router-dom";
import { DateField } from "@mui/x-date-pickers/DateField";
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from 'dayjs';




type DateFieldProps = {
  value: Date,
  onChange: (value: Date) => void
}

const DateFieldComponent = ({ value, onChange }: DateFieldProps) => {

  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);
//  const [selectedDate, setSelectedDate] = useState<Date>(value);
  const anchorRef = useRef<HTMLDivElement | null>(null);

  const handleChange = (newCalendarValue: any) => {
    const newValue = new Date(newCalendarValue);
    onChange(newValue);
  }

  const openCalendar = (event: React.MouseEvent<HTMLElement>) => {
    setOpen(true);
  }

  const closeCalendar = () => {
    setOpen(false);
//    const value = new Date(selectedDate);
//    onChange(value, filter);
  }

  const changeDate = (date: Date) => {
    onChange(date)
// setSelectedDate(date);
  }

  const label = 'Date of Follow Up Meeting'

  return (
      <>
        <Box ref={anchorRef}>
          <DateField
             disabled={true}
             variant="filled"
             fullWidth
             label={label}
             value={dayjs(value)}
             format="DD.MM.YYYY"
             onChange={(newCalendarValue: any) => handleChange(newCalendarValue)}
             InputProps={{
              disableUnderline: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={(event) => openCalendar(event)}>
                    <ScheduleIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            >
          </DateField>
          </Box>

          <Popover
            open={open}
            anchorEl={anchorRef.current}
            onClose={closeCalendar}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Box>

              <DateCalendar
                disabled={false}
                value={dayjs(value)}
                onChange={(newCalendarValue: any) => changeDate(newCalendarValue)}
                shouldDisableDate={(date)=> {const day=date.day();
                                             return day===0 || day===6}}
              />
            </Box>
            <Box
               sx={{display: "flex",
                    justifyContent: "flex-end"}}
            >
              <Button
                 size="small"
                 onClick={() => closeCalendar()}
                 variant='contained'
              >
                  <CheckIcon />
              </Button>
            </Box>
          </Popover>
      </>
    );



};



type CartPriceEntryProps = {
  name: string,
  quantity: number | null | undefined,
  unitPrice: number,
  totalPrice: number
}

const CartPriceEntry = ({ name, quantity, unitPrice, totalPrice }: CartPriceEntryProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <Typography
        variant='body2'
      >
        {name}
      </Typography>
      <Typography
        variant='body2'
      >
        {formatPrice(totalPrice, 'EUR')}
      </Typography>
    </Box>
  )
}


type QuantityControlProps = {
  product: ProductModel,
  disabled: boolean,
  onIncrease: () => void,
  onDecrease: () => void
}

const QuantityControlCol = ({ product, disabled, onIncrease, onDecrease }: QuantityControlProps) => {
  const quantity=product.quantity;
  const maxQuantity=product.maxQuantity;

  const plusColor = '#396A32'
  const minusColor = '#D66A4E'

  const redOrange='#D66A4E'
  const redOrangeLight='#EA9D88'
  const redOrangeDark='#9A3A22'

  const green = '#59A14F'
  const greenLight = '#9BBF72'
  const greenDark = '#396A32'

  //discount in percent
  const discount = 100.*(product.listPrice-product.unitPrice)/product.listPrice

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Typography
          sx={{
            color: 'text.secondary',
            fontWeight: 600
          }}
        >
          {product.name}
        </Typography>
        <Typography
          sx={{
            color: 'text.secondary',
            fontWeight: 600
          }}
        >
          {formatPrice(product.unitPrice, 'EUR')}
        </Typography>
        {(discount >= 0.5) &&
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 1
            }}
          >
          <Typography
            sx={{
              color: 'error.main',
              fontSize: '0.8rem',
              fontWeight: 500
            }}
          >
            {(discount.toFixed(0))}%
          </Typography>
          <Typography
            sx={{
              color: 'text.secondary',
              fontSize: '0.8rem',
              fontWeight: 500
            }}>
            vs. {formatPrice(product.listPrice, 'EUR')}
          </Typography>
          </Box>
        }
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 4,
          backgroundColor: quantity > 0 ? greenLight : 'transparent'
        }}
      >
        <IconButton
          size="small"
          onClick={onDecrease}
          disabled={disabled || quantity <= 0}
          sx={{
            color: redOrange
          }}
        >
          <RemoveIcon fontSize="small"/>
        </IconButton>

        <Typography
          sx={{
            minWidth: 32,
            textAlign: "center",
            fontWeight: 500
          }}
        >
          {quantity}
        </Typography>

        <IconButton
          size="small"
          onClick={onIncrease}
          disabled={disabled || quantity >= maxQuantity}
          sx={{
            color: greenDark
          }}
        >
          <AddIcon fontSize="small"/>
        </IconButton>
      </Box>
    </Box>

  )
}

const QuantityControlRow = ({ product, disabled, onIncrease, onDecrease }: QuantityControlProps) => {
  const quantity=product.quantity;
  const maxQuantity=product.maxQuantity;

  const plusColor = '#396A32'
  const minusColor = '#D66A4E'

  const redOrange='#D66A4E'
  const redOrangeLight='#EA9D88'
  const redOrangeDark='#9A3A22'

  const green = '#59A14F'
  const greenLight = '#9BBF72'
  const greenDark = '#396A32'


  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        gap: 4
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Typography
          sx={{
            color: 'text.secondary',
            fontWeight: 600
          }}
        >
          {product.name}
        </Typography>
        <Typography
          sx={{
            color: 'text.secondary',
            fontWeight: 500
          }}
        >
          {formatPrice(product.unitPrice, 'EUR')}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 4,
          backgroundColor: quantity > 0 ? greenLight : 'transparent'
        }}
      >
        <IconButton
          size="small"
          onClick={onDecrease}
          disabled={disabled || quantity <= 0}
          sx={{
            color: redOrange
          }}
        >
          <RemoveIcon fontSize="small"/>
        </IconButton>

        <Typography
          sx={{
            minWidth: 32,
            textAlign: "center",
            fontWeight: 500
          }}
        >
          {quantity}
        </Typography>

        <IconButton
          size="small"
          onClick={onIncrease}
          disabled={disabled || quantity >= maxQuantity}
          sx={{
            color: greenDark
          }}
        >
          <AddIcon fontSize="small"/>
        </IconButton>
      </Box>
    </Box>

  )
}





type EventProductsTabProps = {
  eventProducts: EventProductModel[],
  isLoading: boolean,
  increaseProduct: (product_uuid: string) => void
  decreaseProduct: (product_uuid: string) => void,
}

const EventProductsTabComponent = ({eventProducts,
                                    isLoading,
                                    increaseProduct,
                                    decreaseProduct}: EventProductsTabProps) => {

  const styles = ContainerClasses();

  const circleTypes = [
    {key: 'ALL', label: 'All'},
    {key: 'CFO', label: 'CFO'},
    {key: 'CHRO', label: 'CHRO'},
    {key: 'CIO', label: 'CIO'},
    {key: 'CISO', label: 'CISO'},
    {key: 'CPO', label: 'CPO'},
    {key: 'CSCO', label: 'CSCO'},
    {key: 'CXO', label: 'CXO'}
  ]
  const regions = [
    {key: 'ALL', label: 'All'},
    {key: 'North', label: 'North'},
    {key: 'South', label: 'South'},
    {key: 'West', label: 'West'}
  ]
  const countries = [
    {key: 'ALL', label: 'All'},
    {key: 'Germany', label: 'Germany'},
    {key: 'Switzerland', label: 'Switzerland'}
  ]

  const [circleTypeFilter, setCircleTypeFilter] = useState<string>('ALL');
  const [regionFilter, setRegionFilter] = useState<string>('ALL');
  const [countryFilter, setCountryFilter] = useState<string>('ALL');


  const renderRow = (eventProduct: EventProductModel) => {

    return (
      <Box
        key={eventProduct.event.uuid}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          backgroundColor: 'background.paper',
          borderTop: '1px solid',
          borderBottom: '1px solid',
          borderColor: '#e0e0e0',
          pt: 2,
          pb: 2,
          '&:hover': {
            filter: 'brightness(0.95)'
          }
        }}
      >
         <Typography
           sx={{
             color: 'text.secondary',
             fontWeight: 600
           }}
           variant='h6'
          >
           {eventProduct.event.name}
         </Typography>
         <Box sx={{
           width: '100%',
           display: 'flex',
           flexDirection: 'row',
           justifyContent: 'space-around',
           gap: 2,
         }}>
           {eventProduct.products.map((thisProduct: ProductModel) => {
             return (
               <QuantityControlCol
                 key={thisProduct.uuid}
                 product={thisProduct}
                 disabled={isLoading}
                 onIncrease={() => increaseProduct(thisProduct.uuid)}
                 onDecrease={() => decreaseProduct(thisProduct.uuid)}
              />
             )

           })}

         </Box>
      </Box>
    )
  }


  const filteredEventProducts = eventProducts.filter((eventProduct: EventProductModel) => {
    if(countryFilter === 'ALL') return true
    if(eventProduct.event.country === countryFilter) return true
    return false
  }).filter((eventProduct: EventProductModel) => {
    if(regionFilter === 'ALL') return true
    if(eventProduct.event.regions.includes(regionFilter)) return true
    return false
  }).filter((eventProduct: EventProductModel) => {
    if(circleTypeFilter === 'ALL') return true
    if(eventProduct.event.circleTypes.includes(circleTypeFilter)) return true
    return false
  })

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        mt: 2
      }}
    >
      <Grid container spacing = {3}>
        <Grid item xs={12} md={4}>
          <FormControl
            fullWidth
            variant="filled"
          >
            <InputLabel>
              Country
            </InputLabel>
            <Select
              value={countryFilter}
              onChange={(e) => setCountryFilter(e.target.value)}
              size="small"
              disabled={false}
            >
              {countries.map((country) => {
                return (
                  <MenuItem
                    key={country.key}
                    value={country.key}
                  >
                    {country.label}
                  </MenuItem>
                )
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={4}>
          <FormControl
            fullWidth
            variant="filled"
          >
            <InputLabel>
              Circle Type
            </InputLabel>
            <Select
              value={circleTypeFilter}
              onChange={(e) => setCircleTypeFilter(e.target.value)}
              size="small"
              disabled={false}
            >
              {circleTypes.map((circleType) => {
                return (
                  <MenuItem
                    key={circleType.key}
                    value={circleType.key}
                  >
                    {circleType.label}
                  </MenuItem>
                )
              })}
            </Select>
          </FormControl>
        </Grid>


        <Grid item xs={12} md={4}>
          <FormControl
            fullWidth
            variant="filled"
          >
            <InputLabel>
              Region
            </InputLabel>
            <Select
              value={regionFilter}
              onChange={(e) => setRegionFilter(e.target.value)}
              size="small"
              disabled={false}
            >
              {regions.map((region) => {
                return (
                  <MenuItem
                    key={region.key}
                    value={region.key}
                  >
                    {region.label}
                  </MenuItem>
                )
              })}
            </Select>
          </FormControl>
        </Grid>

      </Grid>

      <Divider/>

      <Box>
        {filteredEventProducts.map((eventProduct: EventProductModel) => {
          return(
            renderRow(eventProduct)
          )
        })
        }
      </Box>

    </Box>

  )
}

/**************************************/

type OtherProductsTabProps = {
  products: ProductModel[],
  isLoading: boolean,
  increaseProduct: (product_uuid: string) => void
  decreaseProduct: (product_uuid: string) => void,
}

const OtherProductsTabComponent = ({products,
                                    isLoading,
                                    increaseProduct,
                                    decreaseProduct}: OtherProductsTabProps) => {

  const styles = ContainerClasses();

  const renderRow = (product: ProductModel) => {

    return (
      <Box
        key={product.uuid}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          backgroundColor: 'background.paper',
          borderTop: '1px solid',
          borderBottom: '1px solid',
          borderColor: '#e0e0e0',
          pt: 2,
          pb: 2,
          '&:hover': {
            filter: 'brightness(0.95)'
          }
        }}
      >
         <Box sx={{
           width: '100%',
           display: 'flex',
           flexDirection: 'row',
           justifyContent: 'space-around',
           gap: 2,
         }}>
             <QuantityControlRow
                 product={product}
                 disabled={isLoading}
                 onIncrease={() => increaseProduct(product.uuid)}
                 onDecrease={() => decreaseProduct(product.uuid)}
              />
         </Box>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        mt: 2
      }}
    >
      <Box>
        {products.map((product: ProductModel) => {
          return(
            renderRow(product)
          )
        })
        }
      </Box>

    </Box>

  )
}




/******************************************/


export const CartAComponent: React.FC<{
  context: any,
  onSubmit: () => void
}> = ({
  context,
  onSubmit
}) => {

  /******************************/

  const styles = ContainerClasses();
  const { enqueueSnackbar } = useSnackbar();

  let {appName, objectName} = useParams();
  const navigate = useNavigate();

  type TabKey = 'eventProducts' | 'otherProducts' | 'cart'
  const [selectedTab, setSelectedTab] = useState<TabKey>('eventProducts');

  const cartFactory = new CartAFactory()
  const [cart, setCart] = useState<CartAModel>(cartFactory.init());
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [followUpDate, setFollowUpDate] = useState<Date>(new Date());

  /******************************/

  const {accessToken, onInvalidToken} = useAuth();

  useEffect(() => {
    setIsLoading(true)
    retrieveCart(accessToken, 'CartA')
       .then((data: {cart: CartAModel}) => {
         setCart(data.cart)
       })
       .catch((err) => {
          enqueueSnackbar(
            `Error: ${err.message}`,
            {
              variant: "error",
            }
         )
       })
       .finally(() => {
         setIsLoading(false)
       })
  }, []);

  /******************************/

  const increaseProduct = (product_uuid: string) => {
    const selectedProductUuids = [...cart.selectedProductUuids]
    selectedProductUuids.push(product_uuid)
    setIsLoading(true)
    refreshCart(accessToken, 'CartA', selectedProductUuids)
       .then((data: {cart: CartAModel}) => {
         setCart(data.cart)
       })
       .catch((err) => {
          enqueueSnackbar(
            `Error: ${err.message}`,
            {
              variant: "error",
            }
         )
       })
       .finally(() => {
         setIsLoading(false)
       })
  }

  const decreaseProduct = (product_uuid: string) => {
    const selectedProductUuids = [...cart.selectedProductUuids]
    const index = selectedProductUuids.lastIndexOf(product_uuid)
    if(index !== -1) {
      selectedProductUuids.splice(index,1);
    }
    setIsLoading(true)
    refreshCart(accessToken, 'CartA', selectedProductUuids)
       .then((data: {cart: CartAModel}) => {
         setCart(data.cart)
       })
       .catch((err) => {
          enqueueSnackbar(
            `Error: ${err.message}`,
            {
              variant: "error",
            }
         )
       })
       .finally(() => {
         setIsLoading(false)
       })
  }


  const submitCartProducts = () => {
    setIsLoading(true)
    submitCart(accessToken, 'CartA', cart.selectedProductUuids, followUpDate, context)
       .then((data: any) => {
         if(data?.opportunity_uuid){
           const recordUuid = data.opportunity_uuid
           const objectApiName = 'Opportunity_c'
           const appApiName = getAppName(appName)
           navigate(`/${appApiName}/${objectApiName}/${recordUuid}`);
           onSubmit()
         } else {
           enqueueSnackbar('Unhandled Error: no opportunity created. Please contact the system administrator',
                           {variant: "error",})
         }
       })
       .catch((err) => {
          enqueueSnackbar(
            `Error: ${err.message}`,
            {
              variant: "error",
            }
         )
       })
       .finally(() => {
         setIsLoading(false)
       })
  }



  /******************************/
  /******************************/
  /******************************/


  const renderEventProducts = () => {
    return (
      <EventProductsTabComponent
        eventProducts={cart.eventProducts}
        increaseProduct={increaseProduct}
        decreaseProduct={decreaseProduct}
        isLoading={isLoading}
      />
    )
  }

  const renderOtherProducts = () => {
    return (
      <OtherProductsTabComponent
        products={cart.otherProducts}
        increaseProduct={increaseProduct}
        decreaseProduct={decreaseProduct}
        isLoading={isLoading}
      />
    )
  }

  const renderCart = () => {
    const bookedEventProducts = cart.eventProducts.filter((eventProduct: EventProductModel) =>
              eventProduct.products.filter((product: ProductModel) => product.quantity >= 1).length >= 1);
    const bookedOtherProducts = cart.otherProducts.filter((product: ProductModel) => product.quantity >= 1);
    return (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          backgroundColor: 'white',
          mt: 2,
          pt: 2,
          pb: 2,
          borderRadius: 2,
        }}
      >
          {bookedEventProducts.map((eventProduct: EventProductModel) => {
            let sum = 0.
            return (
              <Box
                key={eventProduct.event.uuid}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  ml: 2,
                  mr: 2
                }}
              >
              <Divider sx={{mt: 2, width: '100%'}}/>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%'
                }}
              >
                <Typography
                   variant='h6'
                   sx={{
                     fontWeight: 600,
                     color: 'text.secondary'
                   }}
                >
                  {eventProduct.event.name}
                </Typography>
              </Box>
              {eventProduct.products.map((product: ProductModel) => {
                if(product.quantity === 0) return
                sum = sum + product.unitPrice;
                return (
                  <CartPriceEntry
                    key={product.uuid}
                    name={product.name}
                    quantity={product.quantity}
                    unitPrice={product.unitPrice}
                    totalPrice={product.quantity*product.unitPrice}
                  />
                )
              })}
              <Divider sx={{width: '100%'}}/>
                <CartPriceEntry
                  name={'Sum'}
                  quantity={null}
                  unitPrice={sum}
                  totalPrice={sum}
                />
              </Box>
            )
          })}

          {bookedOtherProducts.length >= 1 &&
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 1
              }}
            >
             <Divider/>
             <Divider/>
            </Box>
          }

          {bookedOtherProducts.map((product: ProductModel) => {
            return (
              <Box
                key={product.uuid}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  ml: 2,
                  mr: 2
                }}
              >
                <CartPriceEntry
                  name={product.name}
                  quantity={product.quantity}
                  unitPrice={product.unitPrice}
                  totalPrice={product.quantity*product.unitPrice}
                />
              </Box>
            )
          })}

          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: 1
            }}
          >
           <Divider/>
           <Divider/>
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              ml: 2,
              mr: 2
            }}
          >
            <CartPriceEntry
               name={'Total Sum'}
               quantity={null}
               unitPrice={cart.totalPrice}
               totalPrice={cart.totalPrice}
            />
          </Box>


          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              ml: 2,
              mr: 2,
              gap: 2
            }}
          >
           <DateFieldComponent
              value={followUpDate}
              onChange={setFollowUpDate}
           />

            <Button
              variant="contained"
              color="primary"
              disabled={cart.selectedProductUuids.length < 1}
              onClick={() => submitCartProducts()}
            >
              <Typography
                 variant='body2'
              >
                Submit
              </Typography>
              <ShoppingCartCheckoutIcon
                 fontSize="small"
                 sx={{ml: 2,
                    fontSize: 20,
                    fontWeight: 500,
                    transform: "translateY(-0.075em)"
                  }}
                />
            </Button>
          </Box>

      </Box>
    )
  }


  /******************************/

  const renderTabContent = () => {
    switch(selectedTab){
      case 'eventProducts':
        return renderEventProducts()
      case 'otherProducts':
        return renderOtherProducts()
      case 'cart':
        return renderCart()
      default:
        return null;
    }
  }

  /******************************/

  return (
    <Card sx={styles.containerCard}>
      <CardContent>
        <Tabs
          value={selectedTab}
          onChange={(event, newValue) => setSelectedTab(newValue)}
        >
          <Tab
            key={'eventProducts'}
            value={'eventProducts'}
            label={'Events'}
          />
          <Tab
            key={'otherProducts'}
            value={'otherProducts'}
            label={'Other'}
          />
          <Tab
            key={'cart'}
            value={'cart'}
            label={`Cart (${formatPrice(cart.totalPrice, 'EUR')})`}
          />
        </Tabs>

          {/*This Box is always being shown,
            so no layoutshift when displaying linear progress*/}
          <Box sx={{height: 24}}>
            {isLoading &&
              <>
                <Typography
                  variant='body2'
                  color='text.secondary'
                >
                  Fetching and calculating all products and discounts ...
                </Typography>
                <LinearProgress
                  color='primary'
                  variant='indeterminate'
                />
              </>
            }
          </Box>
        {renderTabContent()}

      </CardContent>
    </Card>
  )
}
